<!--Scroll to top-->
<div class="scroll-to-top" (click)="scrollToTop()" [ngClass]="{'show-scrollTop': windowScrolled}">
    <fa-icon size="2x" [icon]="faChevronUp"></fa-icon>
</div>

